import { call, put, delay } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { getHighestRatedCoursesActions } from "../slices";

function* getHighestRatedCoursesWorker() {
  yield delay(300);
  try {
    yield put(getHighestRatedCoursesActions.pending());
    const response = yield call(courseAPI.exploreCourse, {
      Orderby: "avgRate desc",
      PageSize: 30,
      PageNumber: 1,
      status: 1,
      IsActive: true,
      IsPurchased: false,
      IsEnrollemt: false,
    });
    yield put(getHighestRatedCoursesActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getHighestRatedCoursesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getHighestRatedCoursesWorker };
